import { Box, Button } from '@mui/material';
import styled from 'styled-components';

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  '@media (max-width: 786px)': {
    flexDirection: 'column',
    gap: '14px'
  },
  '@media (max-width: 630px)': {
    flexDirection: 'column',
    gap: '12px'
  }
}));

export const ButtonWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
  alignItems: 'flex-end',
  marginLeft: '8px',
  width: '100%'
});

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  borderRadius: '8px !important',
  lineHeight: '1.25 !important'
});
